const loginFormValidation = (email, userPassword) => {
  let validationErrors = {
    emailErr: {},
    passwordErr: {},
  };

  let isValid = true;

  // ✅ EMAIL
  if (!email || email.trim() === "") {
    validationErrors.emailErr.empty = "E-Mail eingeben!";
    isValid = false;
  } else if (!email.includes("@")) {
    validationErrors.emailErr.invalid = "Bitte gültige E-Mail eingeben";
    isValid = false;
  }

  // ✅ PASSWORD
  if (!userPassword || userPassword.trim() === "") {
    validationErrors.passwordErr.empty = "Passwort eingeben!";
    isValid = false;
  }

  return {
    isValid,
    validationErrors,
  };
};

export default loginFormValidation;
